import { isEmailPreferencesPath } from "modules/emailPreferences/emailPreferencesRoute";

const BROWSER_ONLY_HOSTS = ["roadmap.repeatmd.app"];

/**
 * Whether an absolute link to a repeatmd.app host must open in a browser rather than the app.
 *
 * The *.repeatmd.app link claim also captures staff admin hosts (admin.repeatmd.app,
 * admin.dev.repeatmd.app, ...), which always bounce to a browser (T-2193). The promotion email's
 * preferences link is a signed-out page that opens in the browser whichever practice or patient
 * the app is signed in as.
 */
export const isBrowserOnlyAppUrl = (url: URL): boolean => {
  const isAdminHost = url.hostname.startsWith("admin.") && url.hostname.endsWith(".repeatmd.app");

  return (
    isAdminHost || BROWSER_ONLY_HOSTS.includes(url.hostname) || isEmailPreferencesPath(url.pathname)
  );
};
